import PropTypesUtils from '@utils/propTypes'
import PropTypes from 'prop-types'
import c from 'classnames'
import styles from './SujetSelectBox.module.scss'
import RoundMiniIcon from '@components/atoms/RoundMiniIcon/RoundMiniIcon'
import Text from '@components/atoms/Text/Text'

const SujetSelectBox = ({ sujet, selected, onSelect }) => {
  const handleSelect = () => {
    onSelect(sujet.id)
  }
  return (
    <div
      className={c(styles.base, {
        'is-selected': selected,
        'border-brand': selected,
        'border-brandLight': !selected,
      })}
      onClick={handleSelect}
    >
      <div className={styles.icon}>
        <RoundMiniIcon
          bg={selected ? 'white' : false}
          color="brand"
          icon={selected ? 'check' : false}
        />
      </div>

      <div className={styles.img}>
        {(sujet.thumbnail && <img src={sujet.thumbnail} alt={sujet.title} />) ||
          null}
      </div>

      <div className={styles.content}>
        <div className={styles.title}>
          <Text type="text-m" bold>
            {sujet.title}
          </Text>
        </div>

        <div
          className={c(styles.description, {
            'u-block': selected,
          })}
        >
          <Text type="text-xs">{sujet.description}</Text>
        </div>
      </div>
    </div>
  )
}

SujetSelectBox.defaultProps = {}
SujetSelectBox.propTypes = {
  sujet: PropTypesUtils.sujet,
  selected: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
}

export default SujetSelectBox
